import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur-sm border-b border-background-200/70">
      <nav className="max-w-[1280px] mx-auto px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group whitespace-nowrap" aria-label="韩国漫画网首页">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-book-open-line text-lg"></i>
            </div>
            <span className="text-xl font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors hidden sm:block">
              韩国漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/' ? 'bg-primary-100 text-primary-700' : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              首页
            </Link>

            <div className="relative" onMouseEnter={() => setIsCategoryOpen(true)} onMouseLeave={() => setIsCategoryOpen(false)}>
              <button
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap flex items-center gap-1 ${
                  location.pathname.startsWith('/category') ? 'bg-primary-100 text-primary-700' : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
                aria-expanded={isCategoryOpen}
                aria-haspopup="true"
              >
                分类浏览
                <i className={`ri-arrow-down-s-line text-sm transition-transform ${isCategoryOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {isCategoryOpen && (
                <div className="absolute top-full left-0 mt-1 bg-background-50 border border-background-200/70 rounded-lg py-2 w-44" role="menu">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-2 px-4 py-2 text-sm text-foreground-600 hover:text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap"
                      role="menuitem"
                    >
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className={cat.icon}></i>
                      </div>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about' ? 'bg-primary-100 text-primary-700' : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-48 px-3 py-2 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
              />
              <div className="absolute right-2 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-foreground-400">
                <i className="ri-search-line text-sm"></i>
              </div>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-600 hover:bg-background-100 transition-colors"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="切换菜单"
          >
            <i className={`text-xl ${isOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isOpen && (
          <div className="md:hidden pb-4 border-t border-background-200/70">
            <div className="flex flex-col gap-1 pt-3">
              <Link to="/" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-600 hover:text-foreground-900 hover:bg-background-100 transition-colors" onClick={() => setIsOpen(false)}>首页</Link>
              {categories.map((cat) => (
                <Link key={cat.slug} to={`/category/${cat.slug}`} className="flex items-center gap-2 px-4 py-3 rounded-lg text-sm text-foreground-600 hover:text-foreground-900 hover:bg-background-100 transition-colors" onClick={() => setIsOpen(false)}>
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={cat.icon}></i>
                  </div>
                  {cat.name}
                </Link>
              ))}
              <Link to="/about" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-600 hover:text-foreground-900 hover:bg-background-100 transition-colors" onClick={() => setIsOpen(false)}>关于我们</Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}